// vocabulary/high.ts
import { VocabPair } from './types';

export const high: VocabPair[] = [
  { word: "Ubiquitous", definition: "Present everywhere" },
  { word: "Benevolent", definition: "Well-meaning and kind" },
  { word: "Eloquent", definition: "Fluent or persuasive in speaking or writing" },
  { word: "Tenacious", definition: "Tending to keep a firm hold of something" },
  { word: "Paradox", definition: "A statement that contradicts itself but might be true" },
  { word: "Pragmatic", definition: "Dealing with things sensibly and realistically" },
  { word: "Arbitrary", definition: "Based on random choice rather than reason" },
  { word: "Meticulous", definition: "Showing great attention to detail" },
  { word: "Clandestine", definition: "Kept secret or done secretively" },
  { word: "Ephemeral", definition: "Lasting for a very short time" },
  { word: "Juxtaposition", definition: "Placing things side by side for comparison" },
  { word: "Serendipity", definition: "Pleasant surprise or fortunate accident" },
  { word: "Vindicate", definition: "Clear someone of blame or suspicion" },
  { word: "Extrapolate", definition: "Extend or project based on known information" },
  { word: "Nomenclature", definition: "System of naming things in a particular field" },
  { word: "Quintessential", definition: "Most perfect example of a quality" },
];